import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import BurgerMenuItem from './BurgerMenuItem'
import {pushMenuOpen} from 'js/helpers/gtm';
import './burgerMenu.scss'
import CustomScrollBar from "../../../shared/CustomScrollBar"

const getPageNameGA4 = () => window?.drupalSettings?.g4DataLayerCommonVariables?.pagename;

export default class BurgerMenu extends Component {

  static propTypes = {
    menuDataLeft: PropTypes.object,
    menuDataRight: PropTypes.object,
    destinationsMenu: PropTypes.object,
    backButtonLabel: PropTypes.string,
    corporateMenu: PropTypes.object,
    homeUrl: PropTypes.string,
  }

  static defaultProps = {
    corporateMenu: 'Back',
  }

  state = {
    menuOpen: false,
    firstLevel: true,
    secondLevel: false,
    thirdLevel: false,
    activeLevel: 'first',
    activeSecondLevelTitle: '',
    activeThirdLevelTitle: '',
  }

  constructor(props) {
    super(props);
    this.BurgerMenuItems = [];
    this.state = {
      lang: null,
      langHTML: null,
      currency: null,
      currencyTitle: null,
      currencyHTML: null
    }
  }

  componentDidMount() {
    const lang = document.querySelector('.menu-item-cash_lang .current-state')
    const langHTML = lang.innerHTML
    const currencyTitle = document.querySelector('.switchers').dataset.title
    const currency = document.querySelector('.menu-item-cash .current-currency')
    const currencyHTML = currency.innerHTML
    this.setState({
      lang: lang,
      langHTML: langHTML,
      currency: currency,
      currencyTitle: currencyTitle,
      currencyHTML: currencyHTML,
    })
  }

  toogleMenuOpen = () => {
    const {
      menuOpen,
    } = this.state
    this.setState({menuOpen: !menuOpen})
    document.querySelector('body').classList.toggle('menu-opened')
    this.setState({activeLevel: 'first'})
    if (!menuOpen) {
      pushMenuOpen(getPageNameGA4())
    }
  }

  levelsHandler = (levelToActive) => {
    switch(levelToActive) {
      case 'first':
        this.setState({activeLevel: levelToActive})
        this.setState({firstLevel: true})
        this.setState({secondLevel: false})
        this.setState({thirdLevel: false})
        this.closeThirdLevel()
        this.closeSecondLevel()
        break;
      case 'second':
        this.setState({activeLevel: levelToActive})
        this.setState({firstLevel: false})
        this.setState({secondLevel: true})
        this.setState({thirdLevel: false})
        this.closeThirdLevel()
        break;
      case 'third':
        this.setState({activeLevel: levelToActive})
        this.setState({firstLevel: false})
        this.setState({secondLevel: false})
        this.setState({thirdLevel: true})
        break;
    }
  }

  backBtnHandler = () => {
    const {
      activeLevel
    } = this.state
    switch(activeLevel) {
      case 'second':
        this.setState({activeLevel: 'first'})
        this.setState({firstLevel: true})
        this.setState({secondLevel: false})
        this.setState({thirdLevel: false})
        this.setState({activeSecondLevelTitle: ''})
        break;
      case 'third':
        this.setState({activeLevel: 'second'})
        this.setState({firstLevel: false})
        this.setState({secondLevel: true})
        this.setState({thirdLevel: false})
        this.setState({activeThirdLevelTitle: ''})
        break;
    }
  }

  setSecondLevelTitle = (title) => {
    this.setState({activeSecondLevelTitle: title})
  }

  setThirdLevelTitle = (title) => {
    this.setState({activeThirdLevelTitle: title})
  }

  closeSecondLevel = () => {
    this.BurgerMenuItems.forEach(BurgerMenuItem => {
      if(BurgerMenuItem) {
        BurgerMenuItem.closeMenuSecondLevel()
      }
    })
  }

  closeThirdLevel = () => {
    this.BurgerMenuItems.forEach(BurgerMenuItem => {
      if(BurgerMenuItem) {
        BurgerMenuItem.closeMenuThirdLevel()
      }
    })
  }

  fakeCallLang = (e) => {
    const {
      lang,
    } = this.state
    e.preventDefault();
    e.stopPropagation();
    lang.click();
  }

  fakeCallCurrency = (e) => {
    const {
      currency,
    } = this.state
    e.preventDefault();
    e.stopPropagation();
    currency.click();
  }

  render() {
    const {
      menuDataLeft,
      menuDataRight,
      destinationsMenu,
      corporateMenu,
      homeUrl,
      backButtonLabel,
    } = this.props

    const {
      menuOpen,
      firstLevel,
      secondLevel,
      thirdLevel,
      activeLevel,
      activeSecondLevelTitle,
      activeThirdLevelTitle,
      lang,
      langHTML,
      currency,
      currencyTitle,
      currencyHTML,
    } = this.state

    const allMenuItems = { destinationsKey: {...destinationsMenu},...menuDataLeft, ...menuDataRight, ...corporateMenu}

    return (
      <React.Fragment>
        <div className={'mobile-menu'} >
          <div className={cn('mobile-menu__btn', { 'open': menuOpen })}
            onClick={this.toogleMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          {menuOpen &&
            <div className="mobile-menu__container">

              <div className="mobile-menu__breadcrumbs">
                <span className={'mobile-menu__breadcrumbs-item'}
                ><a href={homeUrl}>Home</a></span>
                {(secondLevel || thirdLevel) &&
                  <span className={'mobile-menu__breadcrumbs-item'}
                    onClick={()=>this.levelsHandler('second')}
                  >{activeSecondLevelTitle}</span>
                }
                {thirdLevel &&
                  <span className={'mobile-menu__breadcrumbs-item'}>{activeThirdLevelTitle}</span>
                }

              </div>

              <CustomScrollBar>
                <div className={cn('mobile-menu__levels-wrapper',  activeLevel)}>
                  <div className={cn('mobile-menu__first-level', { 'active': firstLevel })}>

                    {Object.keys(allMenuItems).map((key, index) => {
                        {return <BurgerMenuItem
                          ref={comp => this.BurgerMenuItems[index] = comp}
                          {...allMenuItems[key]}
                          key={index}
                          levelsHandler={this.levelsHandler}
                          backBtnHandler={this.backBtnHandler}
                          setSecondLevelTitle={this.setSecondLevelTitle}
                          setThirdLevelTitle={this.setThirdLevelTitle}
                          backButtonLabel={backButtonLabel}
                        />}
                      }
                    )}

                    { (lang || currency) &&
                      <div className="mobile-menu__switchers">
                        <div className="mobile-menu__switchers-title">{currencyTitle}</div>
                        {lang &&
                          <div className="mobile-menu__switchers-item" onClick={this.fakeCallLang} dangerouslySetInnerHTML={{__html:langHTML}}></div>
                        }
                        {currency &&
                          <div className="mobile-menu__switchers-item mobile-menu__switchers-item_currency" onClick={this.fakeCallCurrency} dangerouslySetInnerHTML={{__html:currencyHTML}}></div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </CustomScrollBar>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}
